import createActions from 'utils/redux/createActions'

export default createActions([
    'NAVIGATE'
])



// WEBPACK FOOTER //
// ./src/actions/routeActions.js